export default __webpack_public_path__ + "images/fa82830bc5a623e26bb1d336ec13f667-music.webp";